import { formatCurrency } from '@if/core/utils'
import { Box } from '@mui/material'
import { FundingSummaryDto } from '@src/types/FundingSummaryDto'
import { useTranslation } from 'react-i18next'
import { InfoRow, SectionHeader } from './shared'

interface Props {
  fundingSummary: FundingSummaryDto
}

const IFinanceMerchantInformation = ({ fundingSummary }: Props) => {
  const { t } = useTranslation()

  return (
    <Box>
      <SectionHeader>{t('fundingSummary.serviceProviderInformation')}</SectionHeader>

      <InfoRow label={t('fundingSummary.internalAccountNumber')} value={fundingSummary?.merchantId?.split('*')[1] ?? fundingSummary?.merchantId} />
      <InfoRow label={t('fundingSummary.contact')} value={fundingSummary?.merchantContact} />
      <InfoRow label={t('fundingSummary.paymentMethod')} value={fundingSummary?.merchantPaymentMethod} />
      <InfoRow label={t('fundingSummary.serviceProvider')} value={fundingSummary?.merchantName} />
      <InfoRow label={t('fundingSummary.address')} value={fundingSummary?.merchantAddress} />
      {fundingSummary?.reducedInterestRate != null && (
        <InfoRow label={t('fundingSummary.promotionalRate')} value={`${fundingSummary.reducedInterestRate}%`} />
      )}
      {fundingSummary?.reducedRateDurationInMonths != null && (
        <InfoRow label={t('fundingSummary.promotionalTerm')} value={`${fundingSummary.reducedRateDurationInMonths}`} />
      )}
      {fundingSummary?.interestRate != null && (
        <InfoRow label={t('fundingSummary.rateOnBalanceAfterTerm')} value={`${fundingSummary.interestRate}%`} />
      )}
      {fundingSummary?.merchantFee && (
        <InfoRow
          label={t('fundingSummary.retainedFee')}
          value={formatCurrency(fundingSummary?.merchantFee)}
        />
      )}
    </Box>
  )
}

export default IFinanceMerchantInformation
